import React, { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Grid,
  Chip,
  CircularProgress,
} from '@mui/material';
import { useStylesTagingDialog } from './Style';
import { Icons } from 'components';
import { useForm, FormProvider } from 'react-hook-form';
import Serivces from '../../../services/SubsetServices';
import useCustomHook from '../../../hooks';

export default function TagingDialog({ open, setOpen, row, tags, getBillTags }) {
  useEffect(() => {
    open && getTagAccountItem();
  }, [open]);
  const classes = useStylesTagingDialog();
  const methods = useForm();
  const { setLoading, loading, isSubmiting, setIsSubmiting, selectedTags, setSelectedTags } =
    useCustomHook();

  const getTagAccountItem = async () => {
    setLoading(true);
    try {
      const obj = {
        documentItemId: row?.documentItemId,
        offset: 0,
        size: 50,
      };
      const res = await Serivces.getListTag(obj);
      if (Array.isArray(res.result) && res.result.length) {
        setSelectedTags(res.result[0]?.tag?.map?.((tag) => tag?.name ?? ''));
      } else {
        setSelectedTags([]);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <Dialog
        onClose={() => setOpen(false)}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="sm"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={() => setOpen(false)}
          className={classes.title}
        >
          برچسب‌ها
          { }
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={() => setOpen(false)}
            size="large">
            <Icons icon='Close' color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          {loading ? (
            <Grid item container style={{ justifyContent: 'center', padding: '32px' }}>
              <CircularProgress size={25} className={classes.buttonProgress} />
            </Grid>
          ) : (
            <Grid
              container
              direction="row"
              alignItems="center"
              spacing={2}
              item
              className={classes.root}
            >
              <Grid container item style={!selectedTags.length ? { justifyContent: 'center' } : {}}>
                {selectedTags.length > 0 ? (
                  selectedTags?.map((t, i) => (
                    <Chip key={i + t} label={t} style={{ margin: '2px', minWidth: '70px' }} />
                  ))
                ) : (
                  <b>موردی یافت نشد</b>
                )}
              </Grid>
              <Grid item>{ }</Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </FormProvider>
  );
}
